export default __webpack_public_path__ + "static/media/stars.d1a9f85d.svg";